<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Invoice template"
                rules="required"
              >
                <MultiSelectInput
                  :required="true"
                  v-model="invoiceTemplateId"
                  :options="documentServices.data"
                  :key="invoiceTemplateId"
                  :multiple="false"
                  :textLabel="$t('invoiceTemplate')"
                  label="name"
                  trackBy="id"
                  :error="errors[0]"
                  moduleName="documentService"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Invoice Correction template"
                rules="required"
              >
                <MultiSelectInput
                  :required="true"
                  v-model="invoiceCorrectionTemplateId"
                  :options="documentServices.data"
                  :key="invoiceCorrectionTemplateId"
                  :multiple="false"
                  :textLabel="$t('invoiceCorrectionTemplate')"
                  label="name"
                  trackBy="id"
                  :error="errors[0]"
                  moduleName="documentService"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Invoice Storno template"
                rules="required"
              >
                <MultiSelectInput
                  :required="true"
                  v-model="invoiceStornoTemplateId"
                  :options="documentServices.data"
                  :key="invoiceStornoTemplateId"
                  :multiple="false"
                  :textLabel="$t('invoiceStornoTemplate')"
                  label="name"
                  trackBy="id"
                  :error="errors[0]"
                  moduleName="documentService"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Payment History template"
                rules="required"
              >
                <MultiSelectInput
                  :required="true"
                  v-model="paymentHistoryTemplateId"
                  :options="documentServices.data"
                  :key="paymentHistoryTemplateId"
                  :multiple="false"
                  :textLabel="$t('paymentHistoryTemplate')"
                  label="name"
                  trackBy="id"
                  :error="errors[0]"
                  moduleName="documentService"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Invoice Summary template"
                rules="required"
              >
                <MultiSelectInput
                  :required="true"
                  v-model="invoiceSummaryTemplateId"
                  :options="documentServices.data"
                  :key="invoiceSummaryTemplateId"
                  :multiple="false"
                  :textLabel="$t('invoiceSummaryTemplate')"
                  label="name"
                  trackBy="id"
                  :error="errors[0]"
                  moduleName="documentService"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <b-button
          variant="primary"
          @click="createDocument"
          :disabled="isFormInvalid"
          class="d-flex align-items-center gap-1"
          v-if="$can(`${$route.meta.permission}.save`)"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("saveTemplate") }}</span>
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import MultiSelect from "vue-multiselect";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import { required, email } from "@validations";
import MultiSelectInput from "@/components/MultiSelectInput.vue";

export default {
  components: {
    TextInput,
    PageHeader,
    MultiSelect,
    ValidationProvider,
    ValidationObserver,
    MultiSelectInput,
  },
  computed: {
    ...mapGetters("documentService", ["documentServices", "count"]),
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("settings"),
          to: "/settings",
        },
        {
          text: this.$t("documentAssignment"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return (
        !this.invoiceTemplateId ||
        !this.invoiceCorrectionTemplateId ||
        !this.invoiceStornoTemplateId ||
        !this.paymentHistoryTemplateId || 
        !this.invoiceSummaryTemplateId
      );
    },
  },
  data() {
    return {
      modelData: {},
      invoiceTemplateId: "",
      invoiceCorrectionTemplateId: "",
      invoiceStornoTemplateId: "",
      paymentHistoryTemplateId: "",
      invoiceSummaryTemplateId: "",
    };
  },
  async mounted() {
    try {
      this.$store.commit("showLoader", true);
      await this.$store.dispatch("documentService/list", {
        limit_start: 0,
        limit_count: 25,
      });

      const response = await this.$store.dispatch(
        "invoices/documentAssignmentList"
      );
      this.modelData = response?.data?.data ?? {};

      try {
        const response = await this.$store.dispatch(
          "documentService/show",
          this.modelData.invoiceTemplateId
        );
        this.invoiceTemplateId = response?.data ?? "";
      } catch (e) {
        this.$store.commit("showLoader", true);
      }
      try {
        const response = await this.$store.dispatch(
          "documentService/show",
          this.modelData.invoiceCorrectionTemplateId
        );
        this.invoiceCorrectionTemplateId = response?.data ?? "";
      } catch (e) {
        this.$store.commit("showLoader", true);
      }
      try {
        const response = await this.$store.dispatch(
          "documentService/show",
          this.modelData.invoiceStornoTemplateId
        );
        this.invoiceStornoTemplateId = response?.data ?? "";
      } catch (e) {
        this.$store.commit("showLoader", true);
      }
      try {
        const response = await this.$store.dispatch(
          "documentService/show",
          this.modelData.paymentHistoryTemplateId
        );
        this.paymentHistoryTemplateId = response?.data ?? "";
      } catch (e) {
        this.$store.commit("showLoader", true);
      }
      try {
        const response = await this.$store.dispatch(
          "documentService/show",
          this.modelData.invoiceSummaryTemplateId
        );
        this.invoiceSummaryTemplateId = response?.data ?? "";
      } catch (e) {
        this.$store.commit("showLoader", true);
      }
    } catch (e) {
      console.error("api error ___", e);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },
  methods: {
    async createDocument() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          try {
            this.$store.commit("showLoader", true);
            await this.$store.dispatch("invoices/saveDocumentAssignment", {
              invoiceTemplateId: this.invoiceTemplateId?.id,
              invoiceCorrectionTemplateId: this.invoiceCorrectionTemplateId?.id,
              invoiceStornoTemplateId: this.invoiceStornoTemplateId?.id,
              paymentHistoryTemplateId: this.paymentHistoryTemplateId?.id,
              invoiceSummaryTemplateId: this.invoiceSummaryTemplateId?.id,
            });
          } catch (e) {
            console.error("api error ___", e);
          } finally {
            this.$store.commit("showLoader", false);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
